import React from 'react';
import { useActiveAds } from '../ActiveAdsContext.js';
import getAspectRatio from './aspect-ratio.js';

export type AdImageType = {
    url?: string;
    path?: string;
    height?: number;
    width?: number;
    aspectRatio?: number;
    sizes?: string;
} & React.PropsWithoutRef<JSX.IntrinsicElements['img']>;

export type ImageSourceOptions = {
    baseCdnUrl?: string;
    defaultResolution?: number;
    fallbackImage?: string;
};

type AdImageProps = {
    alt: string;
    adaptive?: boolean;
    crop?: boolean;
    aspectClass?: string;
    imageClass?: string;
    options?: ImageSourceOptions;
} & Omit<
    AdImageType,
    // omit alt here, because we don't want alt text to be optional
    'alt'
>;

function AdImage(props: AdImageProps) {
    const {
        alt,
        adaptive = false,
        crop = false,
        aspectClass = '',
        imageClass = '',
        url,
        path,
        height,
        width,
        aspectRatio,
        sizes,
        options,
        ...imgProps
    } = props;

    const aspectRatioClassNames = `${adaptive
        ? getAspectRatio({
            aspectRatio,
            height,
            width,
        })
        : ''
        } ${aspectClass} bg-aqua-50`;

    const { urls } = useActiveAds();

    return (
        <div className={aspectRatioClassNames}>
            {
                path ?
                    <img
                        alt={alt ?? "mangler bilde"}
                        className={`${styling.image} ${crop ? styling.crop : styling.contain
                            } ${imageClass}`}
                        loading="lazy"
                        src={path ? `${urls.imageCdn}/${path}` : "https://static.finncdn.no/_c/mfinn/static/images/no-image-text.642b3397.svg"}
                        {...imgProps}
                    />
                    :
                    <img
                        alt={alt ?? "mangler bilde"}
                        loading="lazy"
                        src={"https://static.finncdn.no/_c/mfinn/static/images/no-image.5bf83e47.svg"}
                    />
            }
        </div>
    );
}

const styling = {
    image: 'w-full h-full object-center',
    contain: 'object-contain',
    crop: 'object-cover',
};

export default AdImage;
